function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4004 8H17.4004V6C17.4004 3.24 15.1604 1 12.4004 1C9.64039 1 7.40039 3.24 7.40039 6V8H6.40039C5.30039 8 4.40039 8.9 4.40039 10V20C4.40039 21.1 5.30039 22 6.40039 22H18.4004C19.5004 22 20.4004 21.1 20.4004 20V10C20.4004 8.9 19.5004 8 18.4004 8ZM9.40039 6C9.40039 4.34 10.7404 3 12.4004 3C14.0604 3 15.4004 4.34 15.4004 6V8H9.40039V6ZM18.4004 20H6.40039V10H18.4004V20ZM12.4004 17C13.5004 17 14.4004 16.1 14.4004 15C14.4004 13.9 13.5004 13 12.4004 13C11.3004 13 10.4004 13.9 10.4004 15C10.4004 16.1 11.3004 17 12.4004 17Z",
  fill: "currentColor"
});

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.e037ddcd.svg";
export { ForwardRef as ReactComponent };